/* Customer Reviews HH — stagger fade-in */
(function(){
  'use strict';
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.hh-reviews__card').forEach(el => el.classList.add('is-visible'));
    return;
  }
  function init() {
    document.querySelectorAll('.hh-reviews').forEach(sec => {
      const cards = sec.querySelectorAll('.hh-reviews__card');
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const idx = Array.from(cards).indexOf(entry.target);
            entry.target.style.transitionDelay = (idx % 6) * 80 + 'ms';
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });
      cards.forEach(c => io.observe(c));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
